export const environment = {
  iugoAccount: 'C1896C6BDAFB4099AC7A46FB5A0BD9BC',
  production: true,
  api: {
    url: '#{API_URL}#',
    port: '',
  },
  signalr: {
    url: '#{AUCTION_URL}#',
    port: ''
  },
  web: {
    url: '#{WEB_URL}#',
  },
  mixpanelEnabled: true,
  mixpanelToken: '#{MIXPANEL_TOKEN}#'
};
